// extracted by mini-css-extract-plugin
export default {"editSingleFormSampleContainer":"EditSingleFormSample_editSingleFormSampleContainer__foA9t"};